const header = document.getElementById('SiteHeader');

header.addEventListener('mouseenter', function () {
  // Check if header is NOT sticky
  if (
    !header.classList.contains('site-header--stuck') &&
    !header.classList.contains('site-header--opening')
  ) {
    header.classList.add('active');
  }
});

header.addEventListener('mouseleave', function () {
  header.classList.remove('active');
});